<template>
  <div class="navigation">
    <!-- <div class="topbar">
      <div class="container">
        <el-row type="flex" justify="end">
          <div>
            <span>Last Login: {{ logindate }}</span>
            <span> | </span>
            <span class="button-span" @click="onItemClick($t('route.orders'))">View Your Last Order</span>
          </div>
        </el-row>
      </div>
    </div> -->
    <div class="nav-body">
      <div class="container">
        <el-row class="nav-row" type="flex" justify="space-between">
          <div v-if="($mq.resize && $mq.below('768px'))" class="hamburger">
            <sidebar-toggle v-if="($mq.resize && $mq.below('768px'))"/>
          </div>
          <div class="logo" @click="onItemClick($t('route.home'))">
            <div class="logo-img">
            </div>
          </div>
          <div v-if="($mq.resize && $mq.above('769px'))" class="menu">
            <div>
              <el-row class="icon-button" type="flex" justify="end">
                <span class="orange-button" @click="onItemClick($t('route.orders'))">View Your Last Order</span>
              </el-row>
              <!-- <el-row class="icon-button" type="flex" justify="end">
                <el-dropdown v-if="($mq.resize && $mq.above('769px'))">
                  <el-button type="text">
                    <i class="fa fa-user fa-2x"></i>
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="onItemClick($t('route.profile'))">{{ $t('navbar.profile') }}</el-dropdown-item>
                    <el-dropdown-item @click.native="onItemClick($t('route.orders'))">{{ $t('navbar.orderhistory') }}</el-dropdown-item>
                    <el-dropdown-item @click.native="onLogoutClick()">{{ $t('navbar.logOut') }}</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
                <div @mouseover="onCartHover" @mouseleave="onCartLeave">
                  <el-badge v-if="$store.getters.cartbeers.length > 0" :value="$store.getters.cartbeers.length" class="item">
                    <el-button type="text" @click="onItemClick($t('route.cart'))">
                      <i class="fa fa-shopping-cart fa-2x"></i>
                    </el-button>
                  </el-badge>
                  <el-button v-else type="text" @click="onItemClick($t('route.cart'))">
                    <i class="fa fa-shopping-cart fa-2x"></i>
                  </el-button>
                </div>
              </el-row>
              <cart-pop :popshow="showCartList"/> -->
              <!-- <div class="cart-pop" v-show="showCartList" @mouseover="onPophover" @mouseleave="onPopleave">
                <div class="cart-list">
                  <div class="cart-item" v-for="(item, index) in cartlist" :key="index">
                    <img :src="item.beer.beer_image ? item.beer.beer_image.path : '/static/beer-placeholder.jpg'" />
                    <div class="cart-desc">
                      <span class="cart-title">{{ item.beer.description }}</span>
                      <span class="cart-text">{{ item.beer.description2 }}</span>
                      <span class="cart-text">{{ $t('currency.malaysia') }} {{ item.beer.user_price }}</span>
                      <span class="cart-text">Quantity: {{ item.quantity }}</span>
                      <span class="cart-subtotal">{{ $t('currency.malaysia') }} {{ roundUp(item.beer.user_price * item.quantity) }}</span>
                    </div>
                  </div>
                </div>
                <div class="cart-footer">
                  <div class="cart-total">
                    <span class="title">Total: {{ $t('currency.malaysia') }} {{ totalamount }}</span>
                  </div>
                  <div class="cart-action">
                    <el-button class="orange-button cart-button" @click="onViewCartClick">
                      {{ $t('button.viewcart') }}
                    </el-button>
                  </div>
                </div>
              </div> -->
            </div>
            <el-row v-if="($mq.resize && $mq.above('769px'))" class="nav-button" type="flex" justify="end">
              <el-button type="text" @click="onBrowseClick($t('route.browse'), undefined)">
                {{ $t('navbar.browse') }}
              </el-button>
              <el-button type="text" @click="onItemClick($t('route.promotions'))">
                {{ $t('navbar.promotions') }}
              </el-button>
              <el-button type="text" @click="onItemClick($t('route.faq'))">
                {{ $t('navbar.faq') }}
              </el-button>
              <el-button type="text" @click="onItemClick($t('route.contact'))">
                {{ $t('navbar.contactus') }}
              </el-button>
              <el-dropdown class="navicon-button" v-if="($mq.resize && $mq.above('769px'))">
                <el-button type="text">
                  <unicon name="user" fill="#181C28"></unicon>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="onItemClick($t('route.profile'))">{{ $t('navbar.profile') }}</el-dropdown-item>
                  <el-dropdown-item @click.native="onItemClick($t('route.orders'))">{{ $t('navbar.orderhistory') }}</el-dropdown-item>
                  <el-dropdown-item @click.native="onLogoutClick()">{{ $t('navbar.logOut') }}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <div class="navicon-button" @mouseover="onCartHover" @mouseleave="onCartLeave">
                <el-badge v-if="$store.getters.cartbeers && $store.getters.cartbeers.length > 0" :value="$store.getters.cartbeers.length" class="item">
                  <el-button type="text" @click="onItemClick($t('route.cart'))" class="cart-button">
                    <unicon name="shopping-cart-alt" fill="#181C28"></unicon>
                  </el-button>
                  <cart-pop :popshow="showCartList"/>
                </el-badge>
                <el-button class="cart-button" v-else type="text" @click="onItemClick($t('route.cart'))">
                  <unicon name="shopping-cart-alt" fill="#181C28"></unicon>
                </el-button>
              </div>
            </el-row>
          </div>
          <div v-if="($mq.resize && $mq.below('768px'))" class="nav-cart-container">
            <div class="nav-cart" @click="onItemClick($t('route.cart'))">
              <el-badge v-if="$store.getters.cartbeers.length > 0" :value="$store.getters.cartbeers.length" class="item">
                <el-button type="text">
                  <unicon name="shopping-cart-alt" fill="#181C28"></unicon>
                </el-button>
                <cart-pop :popshow="showCartList"/>
              </el-badge>
              <el-button v-else type="text">
                <unicon name="shopping-cart-alt" fill="#181C28"></unicon>
              </el-button>
            </div>
          </div>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import SidebarToggle from '@/components/SidebarToggle.vue'
import CartPop from '@/components/CartPop.vue'
import { mapGetters } from 'vuex'
export default {
  name: 'Navigation',
  localStorage: {
    beers: {
      type: Array,
      default: []
    }
  },
  components: {
    SidebarToggle,
    CartPop
  },
  computed: {
    ...mapGetters({
      cartlist: 'cartbeers'
    })
  },
  data () {
    return {
      logindate: '',
      totalamount: 0,
      showCartList: false,
      timer: undefined
    }
  },
  mounted () {
    // const val = new Date(this.$store.getters.lastlogin)
    const locale = this.$moment(this.$store.getters.lastlogin + ' +0000', 'YYYY-MM-DD HH:mm:ss Z').tz('Asia/Kuala_Lumpur').format('DD/MM/YYYY')
    this.logindate = locale
  },
  methods: {
    onItemClick (name) {
      this.$router.push({ name, params: { id: 'all' } })
    },
    onBrowseClick (name, obj) {
      this.$router.push({ path: `/browse` })
    },
    onLogoutClick () {
      this.$store.dispatch('LogOut').then(res => {
        location.reload()// In order to re-instantiate the vue-router object to avoid bugs
      }).catch(err => {
        console.log(err)
        location.reload()
      })
    },
    onCartHover () {
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = undefined
      }
      this.showCartList = this.cartlist.length > 0
    },
    onCartLeave () {
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = undefined
      }
      this.timer = setTimeout(() => {
        this.showCartList = false
        this.timer = undefined
      }, 500)
    },
    onToggleSidebar () {
      this.$store.dispatch('toggleSideBar')
    },
    roundUp (value) {
      return (Math.round(value * 100) / 100).toFixed(2)
    }
  }
}
</script>
<style lang="scss">
.icon-button .el-button--medium {
  padding: 0;
}
.el-dropdown-menu--medium .el-dropdown-menu__item {
  color: #181C28;
  font-size: 16px;
  text-transform: uppercase;
  font-family: 'Lato';
  font-weight: bold;
  letter-spacing: 1px;
}
</style>
<style lang="scss" scoped>
@import "@/styles/settings.scss";
.navigation {
  & > .nav-body {
    padding: 15px 0;
    border-bottom: 1px solid #eee;
    .icon-button {
      margin-bottom: 20px;
      .orange-button {
        padding: 5px 20px;
        font-size: 12px;
        cursor: pointer;
      }
      .el-button {
        width: 40px;
        color: #696969;
      }
    }
    .el-badge, .el-dropdown {
      .el-button {
        width: 40px;
        color: #696969;
        padding: 0px 20px;
      }
      // margin-left: 10px;
    }
    .nav-row {
      padding: 0 15px;
      .hamburger {
        display: flex;
        justify-content: center;
        flex-direction: column;
        flex: 1;
      }
      .nav-cart-container {
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: flex-end;
        flex: 1;
        .nav-cart {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 40px;
          height: 40px;
          .item {
            margin-top: 0;
            margin-right: 25px;
          }
        }
      }
    }
    .menu {
      display: flex;
      position: inherit;
      flex-direction: column;
      justify-content: center;
      flex: 1;
      .icon-button {
        & > .el-button {
          width: 40px;
          color: #696969;
          &:hover {
            color: #444;
          }
        }
      }
      .nav-button {
        & > .el-button {
          color: #181C28;
          font-size: $small-title;
          text-transform: uppercase;
          font-family: 'Lato';
          font-weight: bold;
          letter-spacing: 1px;
        }
        & > .el-button+.el-button {
          margin-left: 25px;
        }
      }
    }
  }
  .logo {
    flex: 1;
    display: flex;
    justify-content: center;
    @media (min-width: 768px) {
      justify-content: flex-start;
    }
    .logo-img {
      cursor: pointer;
      width: 65px;
      height: 50px;
      background: url('/static/mybeer-logo-black.svg');
      background-repeat: no-repeat;
      background-size: contain;
      @media (min-width: 768px) {
        width: 125px;
        height: 95px;
      }
    }
  }

  & > .topbar {
    background-color: #363636;
    color: $white-color;
    font-size: $body;
    padding: 5px;
    .el-row {
      padding: 0 15px;
    }
  }

  // .cart-button {
  //   letter-spacing: normal;
  // }
  .cart-button {
    width: 40px;
    padding: 0px 20px;
  }
  .navicon-button {
    display: flex;
    align-items: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Navigation.vue